/**
 * Token过期检测工具
 * 用于检测用户登录Token是否已过期
 */
import router from '@/router'
import ElementUI from 'element-ui'
import myaxios from '@/myaxios'

let checkTimer = null
let isCheckingExpiration = false
let isShowingExpiredDialog = false // 防止重复弹出对话框

/**
 * 启动Token过期检测
 * @param {Object} root - Vue根实例，用于访问配置
 */
export function startTokenExpirationCheck(root) {
    // 如果已经在检测中，先停止
    stopTokenExpirationCheck()

    const expirationTime = sessionStorage.getItem(`tokenExpirationTime`)

    // 如果没有设置过期时间，则不启动检测
    if (!expirationTime) {
        console.log(`Token未设置过期时间，不启动过期检测`)
        console.log(`sessionStorage中的tokenExpirationTime:`, expirationTime)
        return
    }

    isCheckingExpiration = true
    console.log(`========== Token过期检测已启动 ==========`)
    console.log(`过期时间: ${new Date(parseInt(expirationTime)).toLocaleString()}`)
    console.log(`当前时间: ${new Date().toLocaleString()}`)
    console.log(`=========================================`)

    // 立即执行一次检测
    checkTokenExpiration(expirationTime)

    // 检查间隔时间
    checkTimer = setInterval(() => {
        checkTokenExpiration(expirationTime)
    }, 300000)
}

/**
 * 停止Token过期检测
 */
export function stopTokenExpirationCheck() {
    if (checkTimer) {
        clearInterval(checkTimer)
        checkTimer = null
        console.log(`Token过期检测已停止`)
    }
    isCheckingExpiration = false
}

/**
 * 检查Token是否过期
 * @param {string} expirationTime - 过期时间戳
 */
function checkTokenExpiration(expirationTime) {
    const now = new Date().getTime()
    const expTime = parseInt(expirationTime)
    const remaining = expTime - now

    // Token已过期
    if (remaining <= 0) {
        handleTokenExpired()
    }
}

/**
 * 处理Token过期
 */
function handleTokenExpired() {
    console.log(`Token已过期，显示过期提示`)
    showTokenExpiredDialog()
}

/**
 * 显示Token过期对话框
 */
function showTokenExpiredDialog() {
    // 如果已经在显示对话框，不要重复弹出
    if (isShowingExpiredDialog) {
        console.log(`过期对话框已经在显示中，跳过`)
        return
    }

    stopTokenExpirationCheck()
    isShowingExpiredDialog = true

    ElementUI.MessageBox.alert(
        `您的登录已过期，请重新登录`,
        `登录过期提示`,
        {
            confirmButtonText: `重新登录`,
            type: `warning`,
            closeOnClickModal: false,
            closeOnPressEscape: false,
            showClose: false,
            callback: () => {
                // 用户点击"重新登录"
                console.log(`用户选择重新登录`)
                isShowingExpiredDialog = false
                redirectToLogin()
            }
        }
    )
}

/**
 * 清除登录信息
 */
function clearLoginInfo() {
    sessionStorage.removeItem(`token`)
    sessionStorage.removeItem(`caToken`)
    sessionStorage.removeItem(`loginTime`)
    sessionStorage.removeItem(`tokenExpirationTime`)
    sessionStorage.removeItem(`doctoken`)
    sessionStorage.removeItem(`clientIp`)
    console.log(`登录信息已清除`)
}

/**
 * 跳转到登录页
 */
function redirectToLogin() {
    // 先调用logout接口记录登出日志
    const clientPath = window.ClientPath ? window.ClientPath.clientPath : ``

    // 调用logout接口
    myaxios.post(`/api/AcisSystem/Authorization/Logout?clientPath=${clientPath}`)
        .then(() => {
            console.log(`登出日志已记录`)
        })
        .catch(e => {
            console.log(`登出日志记录失败:`, e)
        })
        .finally(() => {
            // 无论接口成功与否，都清除登录信息并跳转
            clearLoginInfo()

            const currentPath = router.currentRoute.fullPath
            if (currentPath !== `/login`) {
                router.push({
                    path: `/login`,
                    query: { redirect: currentPath }
                }).catch(err => err)
            }
        })
}

/**
 * 保存Token过期时间
 * @param {Object} root - Vue根实例
 */
export function saveTokenExpirationTime(root) {
    // 从配置中获取过期时间，可能是字符串或数字
    const tokenExpirationHours = root.TokenExpirationHours

    // 转换为数字，处理字符串情况
    const hours = parseFloat(tokenExpirationHours) || 0

    if (hours > 0) {
        const loginTime = new Date().getTime()
        const expirationTime = loginTime + (hours * 60 * 60 * 1000)

        sessionStorage.setItem(`loginTime`, loginTime.toString())
        sessionStorage.setItem(`tokenExpirationTime`, expirationTime.toString())

        console.log(`Token过期时间已保存: ${new Date(expirationTime).toLocaleString()}`)
        console.log(`Token有效期: ${hours} 小时`)
    } else {
        // 如果配置为0或无效值，清除过期时间
        sessionStorage.removeItem(`loginTime`)
        sessionStorage.removeItem(`tokenExpirationTime`)
        console.log(`Token配置为永不过期（配置值: ${tokenExpirationHours}）`)
    }
}

/**
 * 检查是否正在进行过期检测
 */
export function isTokenExpirationCheckActive() {
    return isCheckingExpiration
}

/**
 * 显示Token过期对话框（供外部调用）
 */
export function showExpiredDialog() {
    showTokenExpiredDialog()
}



// WEBPACK FOOTER //
// ./src/utils/tokenExpiration.js